module.exports = __webpack_public_path__ + "img/mano-bank.5516d9b.svg";